import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../Home/Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import Menubar from '../Menubar/Menubar';
const Nofound = () => {
    return (
        <div className="contactBody">
            <div className="row">
                <div className="col-md-1">
                    <Sidebar/>
                </div>
                <div className="col-md-10">
                    <Menubar/>
                        <div className="text-center mt-5">
                            <h4 className=" text-danger"> 404! <span className="text-white">Opps! You are in wrong page</span> </h4>
                            <Link to="/"> <span className="textColor fs-3 ">Go Home</span></Link>
                        </div>
                        <div className="mt-5">
                        <Footer/>
                        </div>                   
                </div>
                <div className="col-md-1">
                </div>
            </div>
        </div>  
    );
};

export default Nofound;